module.exports = __webpack_public_path__ + "img/icon-education.2307757a.svg";